import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import type { DataIdentifier, Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
const NAME_MAX_LENGTH = 1000;
type BasicDataProps = {
  attributes: string[];
  locale?: Locale;
  disabledDis: DataIdentifier[];
  scrubbedDobValue?: string;
};
export const BasicData = t0 => {
  const $ = _c(37);
  const {
    attributes,
    locale,
    disabledDis,
    scrubbedDobValue
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== attributes) {
    t2 = attributes.includes("name");
    $[1] = attributes;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const showName = t2;
  let t3;
  if ($[3] !== attributes) {
    t3 = attributes.includes("dob");
    $[3] = attributes;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const showDob = t3;
  let t4;
  if ($[5] !== attributes) {
    t4 = attributes.includes("nationality");
    $[5] = attributes;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const showNationality = t4;
  let t5;
  if ($[7] !== attributes) {
    t5 = attributes.includes("email");
    $[7] = attributes;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const showEmail = t5;
  let t6;
  if ($[9] !== attributes) {
    t6 = attributes.includes("phone_number");
    $[9] = attributes;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const showPhoneNumber = t6;
  let t7;
  if ($[11] !== disabledDis || $[12] !== locale || $[13] !== scrubbedDobValue || $[14] !== showDob || $[15] !== showName || $[16] !== t) {
    t7 = showName && <><div className="gap-4 grid grid-cols-1 min-[420px]:grid-cols-2!"><Form.Input name={diToFormData("id.first_name")} data-nid-target="first-name" data-dd-privacy="mask" disabled={disabledDis.includes("id.first_name")} autoFocus={true} label={t(_temp)} placeholder={t(_temp2)} rules={{
          required: t(_temp3),
          maxLength: {
            value: NAME_MAX_LENGTH,
            message: t(_temp4)
          }
        }} /><Form.Input name={diToFormData("id.middle_name")} data-nid-target="middle-name" data-dd-privacy="mask" disabled={disabledDis.includes("id.middle_name")} label={t(_temp5)} placeholder={t(_temp6)} rules={{
          maxLength: {
            value: NAME_MAX_LENGTH,
            message: t(_temp7)
          }
        }} /></div><Form.Input name={diToFormData("id.last_name")} data-nid-target="last-name" data-dd-privacy="mask" disabled={disabledDis.includes("id.last_name")} label={t(_temp8)} placeholder={t(_temp9)} rules={{
        required: t(_temp10),
        maxLength: {
          value: NAME_MAX_LENGTH,
          message: t(_temp11)
        }
      }} />{showDob && <Form.Dob name={diToFormData("id.dob")} data-nid-target="dob" data-dd-privacy="mask" disabled={disabledDis.includes("id.dob")} label={t(_temp12)} locale={locale} scrubbedDobValue={scrubbedDobValue} rules={{
        required: scrubbedDobValue ? false : t(_temp13)
      }} />}</>;
    $[11] = disabledDis;
    $[12] = locale;
    $[13] = scrubbedDobValue;
    $[14] = showDob;
    $[15] = showName;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== disabledDis || $[19] !== locale || $[20] !== showNationality || $[21] !== t) {
    t8 = showNationality && <Form.Country data-dd-privacy="mask" name={diToFormData("id.nationality")} disabled={disabledDis.includes("id.nationality")} label={t(_temp14)} placeholder={t(_temp15)} locale={locale ?? "en-US"} rules={{
      required: t(_temp16)
    }} />;
    $[18] = disabledDis;
    $[19] = locale;
    $[20] = showNationality;
    $[21] = t;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== disabledDis || $[24] !== showEmail || $[25] !== t) {
    t9 = showEmail && <Form.Email name={diToFormData("id.email")} data-nid-target="email" data-dd-privacy="mask" disabled={disabledDis.includes("id.email")} label={t(_temp17)} placeholder={t(_temp18)} rules={{
      required: t(_temp19)
    }} />;
    $[23] = disabledDis;
    $[24] = showEmail;
    $[25] = t;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== disabledDis || $[28] !== locale || $[29] !== showPhoneNumber || $[30] !== t) {
    t10 = showPhoneNumber && <Form.Tel name={diToFormData("id.phone_number")} data-nid-target="phone-number" data-dd-privacy="mask" disabled={disabledDis.includes("id.phone_number")} label={t(_temp20)} locale={locale} rules={{
      required: t(_temp21)
    }} />;
    $[27] = disabledDis;
    $[28] = locale;
    $[29] = showPhoneNumber;
    $[30] = t;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t11 = <>{t7}{t8}{t9}{t10}</>;
    $[32] = t10;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  return t11;
};
function _temp($) {
  return $.fields.name.firstName.label;
}
function _temp2($_0) {
  return $_0.fields.name.firstName.placeholder;
}
function _temp3($_1) {
  return $_1.fields.name.firstName.error.empty;
}
function _temp4($_2) {
  return $_2.fields.name.firstName.error.tooLong;
}
function _temp5($_3) {
  return $_3.fields.name.middleName.label;
}
function _temp6($_4) {
  return $_4.fields.name.middleName.placeholder;
}
function _temp7($_5) {
  return $_5.fields.name.middleName.error.tooLong;
}
function _temp8($_6) {
  return $_6.fields.name.lastName.label;
}
function _temp9($_7) {
  return $_7.fields.name.lastName.placeholder;
}
function _temp10($_8) {
  return $_8.fields.name.lastName.error.empty;
}
function _temp11($_9) {
  return $_9.fields.name.lastName.error.tooLong;
}
function _temp12($_10) {
  return $_10.fields.dob.label;
}
function _temp13($_11) {
  return $_11.fields.dob.error.incorrectFormat;
}
function _temp14($_12) {
  return $_12.fields.nationality.label;
}
function _temp15($_13) {
  return $_13.fields.nationality.placeholder;
}
function _temp16($_14) {
  return $_14.fields.nationality.error.required;
}
function _temp17($_15) {
  return $_15.fields.email.label;
}
function _temp18($_16) {
  return $_16.fields.email.placeholder;
}
function _temp19($_17) {
  return $_17.fields.email.error.required;
}
function _temp20($_18) {
  return $_18.fields.phoneNumber.label;
}
function _temp21($_19) {
  return $_19.fields.phoneNumber.error.required;
}